import React from 'react';
import { Table } from 'semantic-ui-react';

// @ts-ignore
import TableHeadTableCell from 'components/TableHeadTableCell';

const TimesheetSubmissionsTableHead = (): React.ReactElement => (
    <Table.Header style={{ fontSize: '14px' }}>
        <Table.Row>
            <TableHeadTableCell label="Reference" value="id" />
            <TableHeadTableCell label="Submitted By" value="createdBy" />
            <TableHeadTableCell label="Submitted At" value="createdAt" />
            <TableHeadTableCell
                label="# Timesheets"
                value="numberOfTimesheets"
            />
            <Table.HeaderCell />
        </Table.Row>
    </Table.Header>
);

export default TimesheetSubmissionsTableHead;
